import { SagaIterator } from "@redux-saga/types";
import { call, put } from "redux-saga/effects";
import { HttpResponseTypeEnum } from "../core/enumerations/ServerRequestStatusEnum";
import { loginRedux } from "../redux/login-redux/LoginRedux";
import { setError } from "../redux/toaster-redux/ToasterRedux";

export function* loginOtpSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.loginOtp, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(loginRedux.actions.loginOtpSuccess(response.data));
    } else {
      yield put(loginRedux.actions.loginOtpFailure(response.data));
      yield put(setError(response));
    }
  } catch (error) {
    yield put(loginRedux.actions.loginOtpFailure(error));
  }
}

export function* loginOtpVerifySaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.loginOtpVerify, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(loginRedux.actions.loginOtpVerifySuccess(response.data));
    } else {
      yield put(loginRedux.actions.loginOtpVerifyFailure(response.data));
      yield put(setError(response));
    }
  } catch (error) {
    yield put(loginRedux.actions.loginOtpVerifyFailure(error));
  }
}

// get Login Activity details
export function* getAllLoginDetailsSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.getAllUserLoginDetails, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(loginRedux.actions.getAllLoginSuccess(response.data));
    } else {
      yield put(loginRedux.actions.getAllLoginFailure(response.data));
    }
  } catch (error) {
    yield put(loginRedux.actions.getAllLoginFailure(error));
  }
}

// change email address
export function* updateEmailSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.updateEmail, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(loginRedux.actions.updateEmailSuccess(response.data));
    } else {
      yield put(loginRedux.actions.updateEmailFailure(response.data));
    }
  } catch (error) {
    yield put(loginRedux.actions.updateEmailFailure(error));
  }
}

// change phone number 
export function* updatePhoneNumberSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.updatePhoneNumber, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(loginRedux.actions.updatePhoneSuccess(response.data));
    } else {
      yield put(loginRedux.actions.updatePhoneFailure(response.data));
    }
  } catch (error) {
    yield put(loginRedux.actions.updatePhoneFailure(error));
  }
}

// set user FCM token for notifications
export function* updateFCMTokenSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.updateFCMToken, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(loginRedux.actions.updateFCMTokenSuccess(response.data));
    } else {
      yield put(loginRedux.actions.updateFCMTokenFailure(response.data));
    }
  } catch (error) {
    yield put(loginRedux.actions.updateFCMTokenFailure(error));
  }
}

// delete user account
export function* DeleteUserSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.deleteAccount, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(loginRedux.actions.deleteAccountSuccess(response.data));
    } else {
      yield put(loginRedux.actions.deleteAccountFailure(response.data));
    }
  } catch (error) {
    yield put(loginRedux.actions.deleteAccountFailure(error));
  }
}

// block user account
export function* BlockUserSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.blockUser, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(loginRedux.actions.blockUserSuccess(response.data));
    } else {
      yield put(loginRedux.actions.blockUserFailure(response.data));
    }
  } catch (error) {
    yield put(loginRedux.actions.blockUserFailure(error));
  }
}

export function* resendLoginOtpSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.resendLoginOtp, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(loginRedux.actions.resendLoginOtpSuccess(response.data));
    } else {
      yield put(loginRedux.actions.resendLoginOtpFailure(response.data));
      yield put(setError(response));
    }
  } catch (error) {
    yield put(loginRedux.actions.resendLoginOtpFailure(error));
  }
}

export function* registerOtpSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.registerOtp, action.payload);
    if (
      response.status === HttpResponseTypeEnum.Success ||
      response.status === HttpResponseTypeEnum.userCreated
    ) {
      yield put(loginRedux.actions.registerOtpSuccess(response.data));
    } else {
      yield put(loginRedux.actions.registerOtpFailure(response.data));
    }
  } catch (error) {
    yield put(loginRedux.actions.registerOtpFailure(error));
  }
}

export function* registerOtpVerifySaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.registerOtpVerify, action.payload);
    if (
      response.status === HttpResponseTypeEnum.Success ||
      response.status === HttpResponseTypeEnum.userCreated
    ) {
      yield put(loginRedux.actions.registerOtpVerifySuccess(response.data));
    } else {
      yield put(loginRedux.actions.registerOtpVerifyFailure(response.data));
      yield put(setError(response));
    }
  } catch (error) {
    yield put(loginRedux.actions.registerOtpVerifyFailure(error));
  }
}

export function* registerResendOtpSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.registerOtp, action.payload);
    if (
      response.status === HttpResponseTypeEnum.Success ||
      response.status === HttpResponseTypeEnum.userCreated
    ) {
      yield put(loginRedux.actions.registerResendOtpSuccess(response.data));
    } else {
      yield put(loginRedux.actions.registerResendOtpFailure(response.data));
      yield put(setError(response));
    }
  } catch (error) {
    yield put(loginRedux.actions.registerResendOtpFailure(error));
  }
}

export function* createProfileSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.createProfile, action.payload);
    if (
      response.status === HttpResponseTypeEnum.Success ||
      response.status === HttpResponseTypeEnum.userCreated
    ) {
      yield put(loginRedux.actions.createProfileSuccess(response.data));
    } else {
      yield put(loginRedux.actions.createProfileFailure(response.data));
      yield put(setError(response));
    }
  } catch (error) {
    yield put(loginRedux.actions.createProfileFailure(error));
  }
}

export function* createProfilePhoneNumberOtpVerifySaga(
  api: any,
  action: any
): SagaIterator {
  try {
    const response = yield call(
      api.createProfilePhoneNumberOtpVerify,
      action.payload
    );
    if (
      response.status === HttpResponseTypeEnum.Success ||
      response.status === HttpResponseTypeEnum.userCreated
    ) {
      yield put(
        loginRedux.actions.createProfilePhoneNumberOtpVerifySuccess(response)
      );
    } else {
      yield put(
        loginRedux.actions.createProfilePhoneNumberOtpVerifyFailure(
          response.data
        ),
        yield put(setError(response))
      );
    }
  } catch (error) {
    yield put(
      loginRedux.actions.createProfilePhoneNumberOtpVerifyFailure(error)
    );
  }
}

export function* createProfilePhoneNumberOtpResendSaga(
  api: any,
  action: any
): SagaIterator {
  try {
    const response = yield call(
      api.createProfileResendPhoneNumberOtp,
      action.payload
    );
    if (
      response.status === HttpResponseTypeEnum.Success ||
      response.status === HttpResponseTypeEnum.userCreated
    ) {
      yield put(
        loginRedux.actions.createProfileResendPhoneNumberOtpSuccess(
          response.data
        )
      );
    } else {
      yield put(
        loginRedux.actions.createProfileResendPhoneNumberOtpFailure(
          response.data
        )
      );
    }
  } catch (error) {
    yield put(
      loginRedux.actions.createProfileResendPhoneNumberOtpFailure(error)
    );
  }
}

export function* checkUserNameAvaibilitySaga(
  api: any,
  action: any
): SagaIterator {
  try {
    const response = yield call(api.checkUserNameAvaibility, action.payload);
    if (
      response.status === HttpResponseTypeEnum.Success ||
      response.status === HttpResponseTypeEnum.userCreated
    ) {
      yield put(
        loginRedux.actions.checkUserNameAvaibilitySuccess(response.data)
      );
    } else {
      yield put(
        loginRedux.actions.checkUserNameAvaibilityFailure(response.data)
      );
    }
  } catch (error) {
    yield put(loginRedux.actions.checkUserNameAvaibilityFailure(error));
  }
}
export function* createUserNameSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.createUserName, action.payload);
    if (
      response.status === HttpResponseTypeEnum.Success ||
      response.status === HttpResponseTypeEnum.userCreated
    ) {
      yield put(loginRedux.actions.createUserNameSuccess(response.data));
    } else {
      yield put(loginRedux.actions.createUserNameFailure(response.data));
    }
  } catch (error) {
    yield put(loginRedux.actions.createUserNameFailure(error));
  }
}

export function* getAllSkillsSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.getAllSkills, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(loginRedux.actions.getAllSkillsSuccess(response.data));
    } else {
      yield put(loginRedux.actions.getAllSkillsFailure(response.data));
    }
  } catch (error) {
    yield put(loginRedux.actions.getAllSkillsFailure(error));
  }
}

export function* CreateUserAddSkills(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.AddUserSkills, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(loginRedux.actions.addUserSkillsSuccess(response.data));
    } else {
      yield put(loginRedux.actions.addUserSkillsFailure(response.data));
    }
  } catch (error) {
    yield put(loginRedux.actions.addUserSkillsFailure(error));
  }
}

export function* createSkillsSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.createSkill, action.payload);
    if (response.status === HttpResponseTypeEnum.userCreated) {
      yield put(loginRedux.actions.createSkillSuccess(response.data));
    } else {
      yield put(loginRedux.actions.createSkillFailure(response.data));
      yield put(setError(response));
    }
  } catch (error) {
    yield put(loginRedux.actions.createSkillFailure(error));
  }
}

export function* getAllCategoriesSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.getAllCategories, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(loginRedux.actions.getAllCategoriesSuccess(response.data));
    } else {
      yield put(loginRedux.actions.getAllCategoriesFailure(response.data));
    }
  } catch (error) {
    yield put(loginRedux.actions.getAllCategoriesFailure(error));
  }
}

export function* getAllRolesSaga(api: any): SagaIterator {
  try {
    const response = yield call(api.getAllRoles);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(loginRedux.actions.getAllRolesSuccess(response.data));
    } else {
      yield put(loginRedux.actions.getAllRolesFailure(response.data));
    }
  } catch (error) {
    yield put(loginRedux.actions.getAllRolesFailure(error));
  }
}

export function* refreshAuthTokenSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.refreshAuthToken, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(loginRedux.actions.refreshAuthTokenSuccess(response.data));
    } else {
      yield put(loginRedux.actions.refreshAuthTokenFailure(response.data));
    }
  } catch (error: any) {
    yield put(loginRedux.actions.refreshAuthTokenFailure(error));
  }
}

export function* logOutUserSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.logOutUser, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      yield put(loginRedux.actions.logOutSuccess(response?.data));
    } else {
      yield put(loginRedux.actions.logOutFailure(response?.data));
    }
  } catch (error: any) {
    yield put(loginRedux.actions.logOutFailure(error));
  }
}

export function* logOutDifferentUserSaga(api: any, action: any): SagaIterator {
  try {
    const response = yield call(api.logOutUser, action.payload);
    if (response.status === HttpResponseTypeEnum.Success) {
      // yield put(loginRedux.actions.logOutSuccess(response?.data));
    } else {
      // yield put(loginRedux.actions.logOutFailure(response?.data));
    }
  } catch (error: any) {
    yield put(loginRedux.actions.logOutFailure(error));
  }
}

export function* registerWithGoogleOAuth(api: any, action: any): SagaIterator {
  try {
    const response: any = yield call(api.registerWithOAuth, action?.payload);
    if (response?.status === HttpResponseTypeEnum.Success) {
      yield put(loginRedux.actions.registerWithGoogleSuccess(response?.data));
    } else {
      yield put(loginRedux.actions.registerWithGoogleFailure(response?.data));
    }
  } catch (error: any) {
    yield put(loginRedux.actions.registerWithGoogleFailure(error));
  }
}

//facebook login saga
export function* registerWithFacebookOAuth(api: any, action: any): SagaIterator {
  try {
    const response: any = yield call(api.registerFacebookWithOAuth, action?.payload);
    if (response?.status === HttpResponseTypeEnum.Success) {
      yield put(loginRedux.actions.registerWithFacebookSuccess(response?.data));
    } else {
      yield put(loginRedux.actions.registerWithFacebookFailure(response?.data));
    }
  } catch (error: any) {
    yield put(loginRedux.actions.registerWithFacebookFailure(error));
  }
}

export function* disconnectAndDestroySessionIdSaga(
  api: any,
  action: any
): SagaIterator {
  try {
    const response: any = yield call(
      api.disconnectAndDestroySessionId,
      action?.payload
    );
    if (response?.status === HttpResponseTypeEnum.Success) {
      yield put(
        loginRedux.actions.disconnectAndDestroySessionIdSuccess(response?.data)
      );
    } else {
      yield put(
        loginRedux.actions.disconnectAndDestroySessionIdFailure(response?.data)
      );
    }
  } catch (error: any) {
    yield put(loginRedux.actions.disconnectAndDestroySessionIdFailure(error));
  }
}

export function* generateSessionIdSaga(api: any, action: any): SagaIterator {
  try {
    const response: any = yield call(api.generateSessionId, action?.payload);
    if (response?.status === HttpResponseTypeEnum.Success) {
      yield put(loginRedux.actions.generateSessionIdSuccess(response?.data));
    } else {
      yield put(loginRedux.actions.generateSessionIdFailure(response?.data));
    }
  } catch (error: any) {
    yield put(loginRedux.actions.generateSessionIdFailure(error));
  }
}
